import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import quote from '../../../content/media-library/quote.svg';

const Quote = ({ quoteText, cite, image, colourScheme, customPadding }) => {
  const blockquoteClasses = classNames('quote-block', {
    [`quote-block--${customPadding}`]: customPadding
  });

  const componentClasses = classNames('quote-block__inner', {
    'quote-block__inner--image': image,
    [`quote-block__inner--${colourScheme}`]: colourScheme
  });

  return (
    <blockquote className={blockquoteClasses}>
      <div className={componentClasses}>
        {image ? (
          <img className="quote-block__img" src={image.src} alt={image.alt} />
        ) : (
          <div className="quote-block__divider">
            <img src={quote} alt="quote icon" />
            <span className="quote-block__line"></span>
          </div>
        )}
        <div className="quote-block__content">
          <p className="quote-block__quote">“{quoteText}”</p>
          <footer className="quote-block__footer">{cite}</footer>
        </div>
      </div>
    </blockquote>
  );
};

Quote.propTypes = {
  quoteText: PropTypes.string.isRequired,
  cite: PropTypes.string,
  image: PropTypes.shape({ src: PropTypes.string, alt: PropTypes.string }),
  colourScheme: PropTypes.oneOf(['light-grey', 'sand', 'neutral-navy', 'dark-navy']),
  customPadding: PropTypes.oneOf(['no-top', 'no-bottom', 'no-top-bottom'])
};

export default Quote;
